module.exports = __webpack_public_path__ + "media/images/flags/mt-281fe0aa0891309955cae592ef12ab23.svg";